import { IMenuItem } from 'types/menu.js';
import { useNormalisedPathname } from 'utilities/router/api-fetch-path.js';
import { NavMenuItem, NavMenuItemOnClick } from './nav-menu-item.js';

export type NavMenuActiveCB = ({ currentUrl, linkUrl }: { currentUrl: string; linkUrl: string }) => boolean;

export const NavMenuItemList = ({
  menu,
  onClick,
  className,
  activeCB,
}: {
  menu: Array<IMenuItem>;
  activeCB: NavMenuActiveCB;
  onClick?: NavMenuItemOnClick;
  className: string;
}) => {
  const path = useNormalisedPathname();
  const result = menu.map((item, index) => (
    <NavMenuItem
      key={index}
      item={item}
      className={className}
      active={activeCB({ currentUrl: path, linkUrl: item.link })}
      onClick={onClick}
    />
  ));
  return result;
};
